var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible || _vm.localVisible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "analytics-exposure",
              rawName: "v-analytics-exposure",
              value: {
                event: "activity_opened",
                key: "rebate_coupon_lottery",
                properties: {
                  activity_id: "rebate_coupon_lottery",
                  activity_name: "返利券抽奖",
                  activity_type: "lottery",
                },
              },
              expression:
                "{ event: 'activity_opened', key: 'rebate_coupon_lottery', properties: { activity_id: 'rebate_coupon_lottery', activity_name: '返利券抽奖', activity_type: 'lottery' } }",
            },
          ],
          staticClass: "cl-modal-mask",
        },
        [
          _c(
            "div",
            {
              staticClass: "cl-modal-panel",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "cl-modal-close",
                  on: { click: _vm.closeModal },
                },
                [_vm._v("×")]
              ),
              _c(
                "div",
                { staticClass: "coupon-lottery" },
                [
                  _c("div", { staticClass: "panel-topband" }, [
                    _c("div", { staticClass: "band-left" }, [
                      _vm._m(0),
                      _c("div", { staticClass: "band-texts" }, [
                        _c("div", { staticClass: "band-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.bannerTitle ||
                                _vm.$t("couponLottery.banner_title")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "band-subtitle" }, [
                          _vm._v(
                            _vm._s(
                              _vm.bannerSubtitle ||
                                _vm.$t("couponLottery.banner_subtitle")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "band-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "rules-btn",
                        on: {
                          click: function ($event) {
                            _vm.showRulesPopup = true
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "rules-icon-circle" }, [
                          _vm._v("!"),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("couponLottery.rules_btn"))),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "purple-banner" }, [
                    _c(
                      "div",
                      {
                        staticClass: "pill-left",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            _vm.showCouponPopup = true
                          },
                        },
                      },
                      [
                        _vm._m(1),
                        _c("div", { staticClass: "pill-texts" }, [
                          _c("div", { staticClass: "pill-title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("couponLottery.daily_draw_title"))
                            ),
                          ]),
                          _c("div", { staticClass: "pill-sub" }, [
                            _vm._v(_vm._s(_vm.dailyStatus)),
                          ]),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "pill-right" }, [
                      _c("div", { staticClass: "pill-texts" }, [
                        _c("div", { staticClass: "pill-title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$cache.getGameCode() === "lycqkr"
                                  ? `오늘 ${_vm.PayAmountLabel} 충전 시 추가 추첨 기회가 해제됩니다!`
                                  : _vm.$t("couponLottery.unlock_extra_tip", {
                                      amount: _vm.PayAmount,
                                    })
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "progress" },
                        [
                          _c("el-progress", {
                            attrs: {
                              percentage: _vm.percentage,
                              "show-text": false,
                              color: "#EA893F",
                              "define-back-color": "#fff",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tabs",
                    {
                      class: { "is-single-tab": _vm.isPrizePoolHidden },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      !_vm.isPrizePoolHidden
                        ? _c(
                            "el-tab-pane",
                            {
                              style: { width: _vm.tabWidth },
                              attrs: {
                                label: _vm.$t("couponLottery.tab_lucky_draw"),
                                name: "first",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "panel" },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-card",
                                            {
                                              staticClass: "box-card",
                                              staticStyle: {
                                                "border-radius": ".2rem",
                                              },
                                              attrs: {
                                                "body-style": "padding: 0px;",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pool-info" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pi-header",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-user",
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(_vm.poolTitle)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "pi-body" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "pi-count",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.userCount
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "pi-unit",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "couponLottery.unit_people"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-card",
                                            {
                                              staticClass: "box-card",
                                              staticStyle: {
                                                "border-radius": ".2rem",
                                              },
                                              attrs: {
                                                "body-style": "padding: 0px;",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "next-draw" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "nd-header",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-time",
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "couponLottery.next_draw"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "nd-body" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "nd-time",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "nd-date",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "couponLottery.tomorrow"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "nd-clock",
                                                            },
                                                            [_vm._v("10:00")]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "nd-countdown",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.countdownDisplay
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-card",
                                    {
                                      staticClass: "box-card",
                                      staticStyle: {
                                        "border-radius": ".2rem",
                                        "margin-top": "20px",
                                      },
                                      attrs: {
                                        "body-style":
                                          "padding: 0px; background: linear-gradient(180deg, #FFE9D6 0%, #F7D3B4 100%);",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "reward-infos" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ri-header" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-gift",
                                                staticStyle: {
                                                  "font-size": ".3rem",
                                                },
                                              }),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "couponLottery.reward_info"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ri-body" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ri-left" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "couponLottery.reward_label"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "couponLottery.winners_label"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "couponLottery.max_use_label"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "couponLottery.validity_label"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ri-right" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        "1" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "couponLottery.unit_piece"
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        "1" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "couponLottery.unit_people"
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "couponLottery.recharge_amount",
                                                            { amount: 49 }
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ri-row" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "couponLottery.validity_hours",
                                                            { hours: 24 }
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-card",
                                    {
                                      staticClass: "box-card",
                                      staticStyle: {
                                        "border-radius": ".2rem",
                                        "margin-top": "20px",
                                      },
                                      attrs: {
                                        "body-style":
                                          "padding: 0px; background: #FCE7B3",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "rules-info" }, [
                                        _c(
                                          "div",
                                          { staticClass: "rules-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "couponLottery.participation_rules"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "ul",
                                          { staticClass: "rules-list" },
                                          [
                                            _c("li", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("couponLottery.rule_1")
                                                )
                                              ),
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("couponLottery.rule_2")
                                                )
                                              ),
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("couponLottery.rule_3")
                                                )
                                              ),
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("couponLottery.rule_4")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "result-cta" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "result-btn",
                                        class: _vm.buttonClass,
                                        attrs: {
                                          disabled: _vm.isButtonDisabled,
                                        },
                                        on: { click: _vm.handlShowWinPopup },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-gift",
                                          staticStyle: { "font-size": ".3rem" },
                                        }),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.buttonText)),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "el-card",
                                    {
                                      staticClass: "box-card",
                                      staticStyle: {
                                        "border-radius": ".2rem",
                                        "margin-top": "20px",
                                      },
                                      attrs: {
                                        "body-style":
                                          "padding: 0px; background: #FCE7B3",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "recent-list" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "rl-title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "couponLottery.recent_winners"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.lotteryRecordList,
                                            function (value) {
                                              return _c(
                                                "div",
                                                { staticClass: "rl-item" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "rl-name" },
                                                    [_vm._v(_vm._s(value.name))]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "rl-date" },
                                                    [_vm._v(_vm._s(value.time))]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          style: { width: _vm.tabWidth },
                          attrs: {
                            label: _vm.$t("couponLottery.tab_my_coupons"),
                            name: "second",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "panel" },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "box-card",
                                  staticStyle: { "border-radius": ".2rem" },
                                  attrs: { "body-style": "padding: 0px;" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "redemption-form" },
                                    [
                                      _c("div", { staticClass: "rf-header" }, [
                                        _c("span", { staticClass: "rf-icon" }, [
                                          _c("i", {
                                            staticClass: "fa fa-gift",
                                          }),
                                        ]),
                                        _c("div", { staticClass: "rf-texts" }, [
                                          _c(
                                            "div",
                                            { staticClass: "rf-title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "couponLottery.redeem_code_title"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("div", { staticClass: "rf-sub" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "couponLottery.redeem_code_sub"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "rf-main" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.redemptionCode,
                                              expression: "redemptionCode",
                                            },
                                          ],
                                          staticClass: "rf-input",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "couponLottery.redeem_code_placeholder"
                                            ),
                                          },
                                          domProps: {
                                            value: _vm.redemptionCode,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.redemptionCode =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "rf-btn",
                                            class: {
                                              "is-loading": _vm.isExchanging,
                                            },
                                            attrs: {
                                              disabled: _vm.isExchanging,
                                            },
                                            on: { click: _vm.handleExchange },
                                          },
                                          [
                                            _vm.isExchanging
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-spinner fa-spin",
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "couponLottery.redeem_btn"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "rf-tip" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("couponLottery.redeem_tip")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "list-header" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "couponLottery.available_coupons",
                                        {
                                          count: Array.isArray(
                                            _vm.rebateDetails
                                          )
                                            ? _vm.rebateDetails.length
                                            : 0,
                                        }
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "coupon-list-container" },
                                _vm._l(
                                  _vm.rebateDetails,
                                  function (coupon, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "coupon-ticket",
                                      },
                                      [
                                        _c("div", { staticClass: "ct-left" }, [
                                          _c(
                                            "div",
                                            { staticClass: "ct-head" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "ct-tag" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-s-ticket",
                                                    staticStyle: {
                                                      "font-size": ".2rem",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "couponLottery.rebate_coupon"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ct-discount" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "ct-percent" },
                                                [_vm._v(_vm._s(coupon.code))]
                                              ),
                                            ]
                                          ),
                                          coupon.limitedState === 1
                                            ? _c(
                                                "span",
                                                { staticClass: "ct-limit" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "couponLottery.limit_use",
                                                        {
                                                          amount: "49.99",
                                                        }
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "ct-time" },
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass: "el-icon-time",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getCountdown(
                                                        coupon.endTime
                                                      )
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ct-obtained" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "couponLottery.obtained_at"
                                                  )
                                                ) + _vm._s(coupon.obtainedTime)
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("div", { staticClass: "ct-right" }, [
                                          _c(
                                            "div",
                                            { staticClass: "ct-status" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "couponLottery.status_available"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showCouponPopup,
                  expression: "showCouponPopup",
                },
              ],
              staticClass: "coupon-popup-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.handlShowCouponPopup = false
                },
              },
            },
            [
              _c("div", { staticClass: "coupon-popup-panel" }, [
                _c(
                  "button",
                  {
                    staticClass: "coupon-popup-close",
                    on: {
                      click: function ($event) {
                        _vm.showCouponPopup = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _c("div", { staticClass: "coupon-popup-header" }, [
                  _c("div", { staticClass: "cp-title" }, [
                    _vm._v(_vm._s(_vm.$t("couponLottery.popup_draw_title"))),
                  ]),
                  _c("div", { staticClass: "cp-subtitle" }, [
                    _vm._v(_vm._s(_vm.$t("couponLottery.popup_draw_sub"))),
                  ]),
                ]),
                _c("div", { staticClass: "coupon-popup-content" }, [
                  _c("div", { staticClass: "cp-image-box" }, [
                    _c("img", {
                      staticClass: "cp-image",
                      attrs: {
                        src: _vm.couponPopupImage,
                        alt: _vm.$t("couponLottery.coupon_alt"),
                      },
                    }),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "cp-btn",
                      class: { "is-loading": _vm.isDrawing },
                      attrs: { disabled: _vm.isDrawing },
                      on: { click: _vm.handlShowCouponPopup },
                    },
                    [
                      _vm.isDrawing
                        ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        : _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("couponLottery.popup_confirm"))
                            ),
                          ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "coupon-popup-footer" }, [
                  _c("div", { staticClass: "cp-probs" }, [
                    _c("div", { staticClass: "cp-prob-header" }, [
                      _c("div", { staticClass: "cp-footer-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("couponLottery.popup_probs_title"))
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "cp-prob-conter" }, [
                      _c(
                        "div",
                        { staticClass: "cp-prob-col" },
                        _vm._l(
                          _vm.probabilities.slice(
                            0,
                            Math.ceil(_vm.probabilities.length / 2)
                          ),
                          function (prob, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "cp-prob-row" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("couponLottery.popup_prob", {
                                        label: prob.label,
                                        value: prob.value,
                                      })
                                    )
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _c("div", { staticClass: "cp-prob-divider" }),
                      _c(
                        "div",
                        { staticClass: "cp-prob-col" },
                        _vm._l(
                          _vm.probabilities.slice(
                            Math.ceil(_vm.probabilities.length / 2)
                          ),
                          function (prob, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "cp-prob-row" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("couponLottery.popup_prob", {
                                        label: prob.label,
                                        value: prob.value,
                                      })
                                    )
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showResultPopup,
                  expression: "showResultPopup",
                },
              ],
              staticClass: "coupon-popup-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showResultPopup = false
                },
              },
            },
            [
              _c("div", { staticClass: "coupon-popup-panel result-panel" }, [
                _c(
                  "button",
                  {
                    staticClass: "coupon-popup-close",
                    on: {
                      click: function ($event) {
                        _vm.showResultPopup = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _c("div", { staticClass: "coupon-popup-header" }, [
                  _c("div", { staticClass: "cp-title" }, [
                    _vm._v(_vm._s(_vm.$t("couponLottery.popup_draw_title"))),
                  ]),
                  _c("div", { staticClass: "cp-subtitle" }, [
                    _vm._v(_vm._s(_vm.$t("couponLottery.popup_draw_sub"))),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "coupon-popup-content result-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "cp-image-box result-image-box" },
                      [
                        _c("img", {
                          staticClass: "cp-image result-image",
                          attrs: {
                            src:
                              _vm.RebateData.codeUrl ||
                              "~@/assets/image/Rebatecoupon.png",
                            alt: _vm.$t(
                              "couponLottery.rebate_coupon_with_value",
                              { percent: _vm.RebateData.code }
                            ),
                          },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "result-info-box" }, [
                      _c("div", {
                        staticClass: "result-main-text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("couponLottery.result_congrats", {
                              percent: _vm.RebateData.code,
                            })
                          ),
                        },
                      }),
                      _c("div", { staticClass: "result-sub-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("couponLottery.result_validity", {
                              hours: 24,
                            })
                          )
                        ),
                      ]),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "cp-btn confirm-btn",
                        on: {
                          click: function ($event) {
                            _vm.showResultPopup = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("couponLottery.confirm")))]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showLosePopup,
                  expression: "showLosePopup",
                },
              ],
              staticClass: "coupon-popup-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showLosePopup = false
                },
              },
            },
            [
              _c("div", { staticClass: "coupon-popup-panel lose-panel" }, [
                _c(
                  "button",
                  {
                    staticClass: "coupon-popup-close",
                    on: {
                      click: function ($event) {
                        _vm.showLosePopup = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _c("div", { staticClass: "coupon-popup-header lose-header" }, [
                  _c("div", { staticClass: "cp-title lose-title" }, [
                    _vm._v(_vm._s(_vm.$t("couponLottery.lose_title"))),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "coupon-popup-content lose-content" },
                  [
                    _vm._m(2),
                    _c("div", { staticClass: "lose-info-box" }, [
                      _c("div", { staticClass: "lose-main-text" }, [
                        _vm._v(_vm._s(_vm.$t("couponLottery.lose_main"))),
                      ]),
                      _c("div", { staticClass: "lose-sub-text" }, [
                        _vm._v(_vm._s(_vm.$t("couponLottery.lose_sub"))),
                      ]),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "cp-btn lose-confirm-btn",
                        on: {
                          click: function ($event) {
                            _vm.showLosePopup = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("couponLottery.confirm")))]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showWinPopup,
                  expression: "showWinPopup",
                },
              ],
              staticClass: "coupon-popup-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showWinPopup = false
                },
              },
            },
            [
              _c("div", { staticClass: "coupon-popup-panel win-panel" }, [
                _c(
                  "button",
                  {
                    staticClass: "coupon-popup-close",
                    on: {
                      click: function ($event) {
                        _vm.showWinPopup = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _c("div", { staticClass: "coupon-popup-header win-header" }, [
                  _c("div", { staticClass: "cp-title win-title" }, [
                    _vm._v(_vm._s(_vm.$t("couponLottery.win_title"))),
                  ]),
                ]),
                _c("div", { staticClass: "coupon-popup-content win-content" }, [
                  _c("div", { staticClass: "win-image-box" }, [
                    _c("img", {
                      staticClass: "win-coupon-img",
                      attrs: {
                        src: _vm.prizeData.codeUrl,
                        alt: _vm.$t("couponLottery.rebate_coupon_with_value", {
                          percent: _vm.prizeData.code,
                        }),
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "win-info-box" }, [
                    _c("div", { staticClass: "win-main-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("couponLottery.win_main", {
                            percent: _vm.prizeData.code,
                          })
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "win-sub-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("couponLottery.win_sub", {
                            amount: "49.99",
                            hours: 24,
                          })
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "cp-btn win-confirm-btn",
                      on: {
                        click: function ($event) {
                          _vm.showWinPopup = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("couponLottery.confirm")))]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showRulesPopup,
                  expression: "showRulesPopup",
                },
              ],
              staticClass: "coupon-popup-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showRulesPopup = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "coupon-popup-panel rules-popup-panel" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "coupon-popup-close rules-close",
                      on: {
                        click: function ($event) {
                          _vm.showRulesPopup = false
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                  _c(
                    "div",
                    { staticClass: "coupon-popup-header rules-popup-header" },
                    [
                      _c("div", { staticClass: "rules-header-content" }, [
                        _vm._m(3),
                        _c("span", { staticClass: "rules-header-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$cache.getGameCode() === "fzsgkr" ||
                                _vm.$cache.getGameCode() === "lycqkr"
                                ? "이벤트 룰"
                                : _vm.$t("couponLottery.rules_popup_title")
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "rules-popup-body" }, [
                    _c(
                      "div",
                      { staticClass: "rules-scroll-content" },
                      _vm._l(_vm.rulesSections, function (section, sIndex) {
                        return _c(
                          "div",
                          { key: sIndex, staticClass: "rules-section" },
                          [
                            _c("div", { staticClass: "rules-sec-title" }, [
                              _c("i", { staticClass: "fa fa-gift" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getRuleText(section.title)) +
                                  "\n            "
                              ),
                            ]),
                            _vm._l(section.items, function (item, iIndex) {
                              return _c(
                                "div",
                                { key: iIndex, staticClass: "rules-item" },
                                [
                                  item.slogan
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "rules-text slogan-text",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.getRuleText(item.slogan)
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  item.subTitle
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "rules-item-sub",
                                          style: {
                                            marginTop:
                                              iIndex > 0 ? "10px" : "0",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.getRuleText(item.subTitle)
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  item.lines
                                    ? _vm._l(
                                        item.lines,
                                        function (line, lIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: lIndex,
                                              staticClass: "rules-text",
                                              class: {
                                                "is-indent": line.indent,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    typeof line === "string"
                                                      ? _vm.getRuleText(line)
                                                      : (line.prefix
                                                          ? `${line.prefix} `
                                                          : "") +
                                                          _vm.getRuleText(
                                                            line.key
                                                          )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c("TipsWindow", {
            ref: "tips",
            staticStyle: { "z-index": "999999", "font-weight": "700" },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "band-icon" }, [
      _c("i", { staticClass: "fa fa-gift" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "pill-icon" }, [
      _c("i", { staticClass: "fa fa-gift" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lose-image-box" }, [
      _c("div", { staticClass: "lose-icon-circle" }, [
        _c("i", { staticClass: "el-icon-present" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "rules-header-icon" }, [
      _c("i", { staticClass: "fa fa-gift" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }